export { default } from "./Typography.js";
export { default as typographyClasses } from "./typographyClasses.js";
export * from "./typographyClasses.js";